(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('ControllerGridDTO', ControllerGridDTO);

    ControllerGridDTO.$inject = ['$resource','DateUtils'];

    function ControllerGridDTO($resource, DateUtils) {
        var resourceUrl = "api/controllerGridDTO/:id";

        return $resource(resourceUrl, {}, {
            'query': {method:'GET',isArray: true},
            'get': {
                method: 'GET',
                transformResponse:function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
